import { Schema } from 'prosemirror-model';
import { addListNodes } from 'prosemirror-schema-list';
import nodes from './nodes';
import marks from './marks';

const initialSchema = new Schema({
  nodes,
  marks,
});

const schemaWithListNodes = addListNodes(initialSchema.spec.nodes, 'paragraph block*', 'block');

const schema = new Schema({
  nodes: schemaWithListNodes,
  marks: initialSchema.spec.marks,
});

export default schema;